module.exports = __webpack_public_path__ + "assets/img/abcb23021b21e83a90483458cc8d6605.webp";